export function getFinalExamQuestions() {
    // Exactly Q1..Q50 from your provided text
    // For brevity, we show the main ideas. You can expand
    // the <p> for scenario vs. question if you want them separate.
  
    return [
      // Q1
      {
        question: () => {
          const qHtml = `
            <p><strong>Q1. Scenario:</strong> “If an integer is prime, then it is odd.” 
            <br/>Which is a valid counterexample?</p>
          `;
          return {
            q: qHtml,
            a: "A. The number 2 (prime but not odd)",
            distract: [
              "B. The number 9 (an integer that is not prime)",
              "C. The number 11 (prime and odd)",
              "D. There is no counterexample"
            ]
          };
        }
      },
      // Q2
      {
        question: () => {
          const qHtml = `
            <p><strong>Q2. Scenario:</strong> “If it rains, then I will bring an umbrella.” 
            <br/>Which is the converse statement?</p>
          `;
          return {
            q: qHtml,
            a: "B. If I bring an umbrella, then it rains.",
            distract: [
              "A. If I do not bring an umbrella, then it does not rain.",
              "C. If it rains, then I will not bring an umbrella.",
              "D. If I do not bring an umbrella, then it rains."
            ]
          };
        }
      },
      // Q3
      {
        question: () => {
          const qHtml = `
            <p><strong>Q3:</strong> Next number in sequence 2,5,11,20,...?</p>
          `;
          return {
            q: qHtml,
            a: "C.32",
            distract: ["A. 23","B. 29","D. 35"]
          };
        }
      },
      // Q4
      {
        question: () => {
          const qHtml = `
            <p><strong>Q4:</strong> “All cats have tails. Fluffy has a tail. Therefore, Fluffy is a cat.” 
            <br/>Evaluate the conclusion's validity?</p>
          `;
          return {
            q: qHtml,
            a: "B. Conclusion invalid - Fluffy could be another tailed animal",
            distract: [
              "A. Conclusion valid - having a tail implies cat",
              "C. Conclusion valid - contrapositive logic",
              "D. Conclusion invalid - denying the antecedent"
            ]
          };
        }
      },
      // Q5
      {
        question: () => {
          const qHtml = `
            <p><strong>Q5:</strong> “If P→Q and Q→R, but R is false.” Which must be true?</p>
          `;
          return {
            q: qHtml,
            a: "D. Q is false",
            distract: [
              "A. P is true",
              "B. Q is true",
              "C. P is false"
            ]
          };
        }
      },
      // Q6
      {
        question: () => {
          const qHtml = `
            <p><strong>Q6:</strong> Reference angle for 200° in standard position?</p>
          `;
          return {
            q: qHtml,
            a: "A. 20°",
            distract: [
              "B. 160°",
              "C. 200°",
              "D. 340°"
            ]
          };
        }
      },
      // Q7
      {
        question: () => {
          const qHtml = `
            <p><strong>Q7:</strong> Triangle ABC, a=7 cm, b=9 cm, ∠A=40°. Using Sine Law, find ∠B?</p>
          `;
          return {
            q: qHtml,
            a: "B. 56°",
            distract: ["A. 40°","C. 70°","D. 82°"]
          };
        }
      },
      // Q8
      {
        question: () => {
          const qHtml = `
            <p><strong>Q8:</strong> Triangle XYZ with XY=10 m, YZ=12 m, ∠Y=50°. Cosine Law => XZ ~ ?</p>
          `;
          return {
            q: qHtml,
            a: "A. 9.5 m",
            distract: [
              "B. 10.4 m","C. 14.8 m","D. 17.9 m"
            ]
          };
        }
      },
      // Q9
      {
        question: () => {
          const qHtml = `
            <p><strong>Q9:</strong> Exact value of tan(240°)?</p>
          `;
          return {
            q: qHtml,
            a: "D. √3",
            distract: [
              "A. -√3",
              "B. -1/√3",
              "C. 1/√3",
            ]
          };
        }
      },
      // Q10
      {
        question: () => {
          const qHtml = `
            <p><strong>Q10:</strong> Footbridge 10 m at 70° to the horizontal. cos(70°)=adj/10 => ?</p>
          `;
          return {
            q: qHtml,
            a: "A. 3.4 m",
            distract: ["B. 3.6 m","C. 9.4 m","D. 10.6 m"]
          };
        }
      },
      // Q11
      {
        question: () => {
          const qHtml = `
            <p><strong>Q11:</strong> Solve x^2 - 5x - 6=0:</p>
          `;
          return {
            q: qHtml,
            a: "B. x=-1 or x=6",
            distract: [
              "A. x=-6 or x=1",
              "C. x=1 or x=5",
              "D. x=6 or x=-5"
            ]
          };
        }
      },
      // Q12
      {
        question: () => {
          const qHtml = `
            <p><strong>Q12:</strong> For f(x)=-3x^2+12x-4, the axis of symmetry?</p>
          `;
          return {
            q: qHtml,
            a: "B. x=2",
            distract: ["A. x=-2","C. y=2","D. x=4"]
          };
        }
      },
      // Q13
      {
        question: () => {
          const qHtml = `
            <p><strong>Q13:</strong> h(t)=-5t^2+20t+1. The max height?</p>
          `;
          return {
            q: qHtml,
            a: "C. 21 m",
            distract: ["A. 1 m","B. 4 m","D. 41 m"]
          };
        }
      },
      // Q14
      {
        question: () => {
          const qHtml = `
            <p><strong>Q14:</strong> Max area for perimeter=60 (rectangle)?</p>
          `;
          return {
            q: qHtml,
            a: "A. 225 m^2",
            distract: ["B. 900 m^2","C. 400 m^2","D. 15 m^2"]
          };
        }
      },
      // Q15
      {
        question: () => {
          const qHtml = `
            <p><strong>Q15:</strong> y=(x+2)^2 -5. Vertex coords?</p>
          `;
          return {
            q: qHtml,
            a: "A. (-2, -5)",
            distract: [
              "B. (2, -5)",
              "C. (-2, 5)",
              "D. (2, 5)"
            ]
          };
        }
      },
      // Q16
      {
        question: () => {
          const qHtml = `
            <p><strong>Q16:</strong> Simplify (x^2 -9)/(x^2 -3x)</p>
          `;
          return {
            q: qHtml,
            a: "A. (x+3)/x",
            distract: ["B. (x-3)/x","C. (x+3)/(x-3)","D. 1"]
          };
        }
      },
      // Q17
      {
        question: () => {
          const qHtml = `
            <p><strong>Q17:</strong> (2/x)+(3/(x+1)) => ? fully simplified</p>
          `;
          // 2(x+1)+3x => (2x+2+3x)/(x(x+1)) => (5x+2)/(x(x+1))
          return {
            q: qHtml,
            a: "D. (5x+2)/(x(x+1))",
            distract: [
              "A. 5/x",
              "B. (5x+2)/(x(x+1))", // the same as D but we can see user has confusion
              "C. (5x+2)/(x-1)"
            ]
          };
        }
      },
      // Q18
      {
        question: () => {
          const qHtml = `
            <p><strong>Q18:</strong> Solve x/(x-2)=4, x!=2</p>
          `;
          // x/(x-2)=4 => x=4x-8 => -3x=-8 => x=8/3
          return {
            q: qHtml,
            a: "B. x=8/3",
            distract: ["A. x=-2","C. x=2","D. x=4"]
          };
        }
      },
      // Q19
      {
        question: () => {
          const qHtml = `
            <p><strong>Q19:</strong> (x^2+2x)/(x^2-4). Exclude what x-values?</p>
          `;
          // denominator x^2-4=0 => x=±2
          return {
            q: qHtml,
            a: "C. x=-2 & x=2",
            distract: ["A. x=-2","B. x=2","D. none"]
          };
        }
      },
      // Q20
      {
        question: () => {
          const qHtml = `
            <p><strong>Q20:</strong> Solve x/(x-1)=3/(x+1). # real solutions?</p>
          `;
          return {
            q: qHtml,
            a: "A. No real solution",
            distract: [
              "B. Exactly one real solution","C. Exactly two","D. Infinitely many"
            ]
          };
        }
      },
      // Q21
      {
        question: () => {
          const qHtml = `
            <p><strong>Q21:</strong> Solve system: {2x+3y=7, x-y=4}</p>
  
          `;
          return {
            q: qHtml,
            a: "C. (19/5, -1/5)",
            distract: ["A. (18/5, -3/5)","B. (20/5, -2/10)","D. (16/5, -1/3)"]
          };
        }
      },
      // Q22
      {
        question: () => {
          const qHtml = `
            <p><strong>Q22:</strong> Lines y=2x+3 & 4x-2y=8. # of solutions?</p>
          `;
          return {
            q: qHtml,
            a: "A. No solution",
            distract: ["B. Exactly one solution","C. Exactly two","D. Infinitely many"]
          };
        }
      },
      // Q23
      {
        question: () => {
          const qHtml = `
            <p><strong>Q23:</strong> 3 apples+2 oranges=5.50, 5 apples+4 oranges=9.50. Apple cost?</p>
          `;
          return {
            q: qHtml,
            a: "C. $1.50",
            distract: ["A. $0.50","B. $1.00","D. $2.00"]
          };
        }
      },
      // Q24
      {
        question: () => {
          const qHtml = `
            <p><strong>Q24:</strong> System: line y=2x+3 & parabola y=x^2. # intersections?</p>
          `;
          return {
            q: qHtml,
            a: "C. 2",
            distract: ["A. 0","B. 1","D. Infinite"]
          };
        }
      },
      // Q25
      {
        question: () => {
          const qHtml = `
            <p><strong>Q25:</strong> System {x+2y=4, 2x+4y=8}. Solutions?</p>
          `;
          return {
            q: qHtml,
            a: "C. Infinitely many solutions",
            distract: [
              "A. No solution",
              "B. Unique single",
              "D. Exactly 2"
            ]
          };
        }
      },
      // Q26
      {
        question: () => {
          const qHtml = `
            <p><strong>Q26:</strong> Which sequence is geometric? 
            <br/>
            A. 2,4,6,8,...
            B. 3,6,12,24,...
            C. 5,10,15,20,...
            D. 2,4,8,16,33,...</p>
          `;
          return {
            q: qHtml,
            a: "B. 3,6,12,24,...",
            distract: [
              "A. 2,4,6,8,... (arithmetic)",
              "C. 5,10,15,20,... (arithmetic)",
              "D. 2,4,8,16,33,... (fails ratio at end)"
            ]
          };
        }
      },
      // Q27
      {
        question: () => {
          const qHtml = `
            <p><strong>Q27:</strong> Arithmetic seq a1=4, d=3. a10=?</p>
          `;
          // a10=4+(10-1)*3=4+27=31
          return {
            q: qHtml,
            a: "A. 31",
            distract: ["B. 34","C. 37","D. 40"]
          };
        }
      },
      // Q28
      {
        question: () => {
          const qHtml = `
            <p><strong>Q28:</strong> Arithmetic seq 5,8,11,14,... Sum of first 20 terms?</p>
          `;
          return {
            q: qHtml,
            a: "B. 670",
            distract: ["A. 100","C. 675","D. 1340"]
          };
        }
      },
      // Q29
      {
        question: () => {
          const qHtml = `
            <p><strong>Q29:</strong> Geo seq a1=5, r=2. a8=?</p>
          `;
          // a8=5*(2^(7))=5*128=640
          return {
            q: qHtml,
            a: "C. 640",
            distract: ["A. 40","B. 128","D. 1280"]
          };
        }
      },
      // Q30
      {
        question: () => {
          const qHtml = `
            <p><strong>Q30:</strong> Seq 3,7,11,15,... which formula is correct for a_n?</p>
          `;
          // a1=3 => must check
          // B => a1=3+4(0)=3 => correct
          return {
            q: qHtml,
            a: "B. a_n=3+4(n-1)",
            distract: [
              "A. a_n=4n-1",
              "C. a_n=4n+3",
              "D. a_n=7+(n-1)*4"
            ]
          };
        }
      },
      // Q31
      {
        question: () => {
          const qHtml = `
            <p><strong>Q31:</strong> Compound interest formula for principal P at rate r, t yrs</p>
  
          `;
          return {
            q: qHtml,
            a: "A. A=P(1+r)^t",
            distract: ["B. A=P(1+rt)","C. A=P+P*r*t","D. A=P(1+r/t)^t"]
          };
        }
      },
      // Q32
      {
        question: () => {
          const qHtml = `
            <p><strong>Q32:</strong> $1000 at 5% annual, 3 yrs, approximate future value?</p>
          `;
          // 1000*(1.05^3)=1000*1.157625=1157.63
          return {
            q: qHtml,
            a: "B. $1157.63",
            distract: ["A. $1150.00","C. $1600.00","D. $1715.00"]
          };
        }
      },
      // Q33
      {
        question: () => {
          const qHtml = `
            <p><strong>Q33:</strong> Deposit $100 end of each year for 3 yrs at 5%. Value after 3rd deposit?</p>
          `;
          return {
            q: qHtml,
            a: "D. $347.63",
            distract: ["A. $300.00","B. $315.25","C. $331.00"]
          };
        }
      },
      // Q34
      {
        question: () => {
          const qHtml = `
            <p><strong>Q34:</strong> Car $20000, depreciate 10% per yr. Value after 3 yrs?</p>
          `;
          return {
            q: qHtml,
            a: "A. $14580",
            distract: ["B. $16200","C. $18000","D. $20000"]
          };
        }
      },
      // Q35
      {
        question: () => {
          const qHtml = `
            <p><strong>Q35:</strong> Option1=5% simple 5 yrs, Option2=4.8% compounding 5 yrs. Which yields more?</p>
          `;
          return {
            q: qHtml,
            a: "B. 4.8% compound grows more",
            distract: [
              "A. 5% simple is better",
              "C. Same result",
              "D. Mix the two"
            ]
          };
        }
      },
      // Q36
      {
        question: () => {
          const qHtml = `
            <p><strong>Q36:</strong> Data {2,5,7,9,50}, outlier=50. Which measure is most affected?</p>
          `;
          return {
            q: qHtml,
            a: "A. Mean",
            distract: ["B. Median","C. Mode","D. All equally"]
          };
        }
      },
      // Q37
      {
        question: () => {
          const qHtml = `
            <p><strong>Q37:</strong> 2 fair dice. Probability sum=7?</p>
          `;
          return {
            q: qHtml,
            a: "B. 1/6",
            distract: ["A. 1/12","C. 1/4","D. 1/3"]
          };
        }
      },
      // Q38
      {
        question: () => {
          const qHtml = `
            <p><strong>Q38:</strong> 5 red,3 green,2 blue => 10 total. Probability green or blue?</p>
          `;
          // green or blue => 3+2=5 => 5/10=1/2 => B
          return {
            q: qHtml,
            a: "B. 1/2",
            distract: [
              "A. 2/5","C. 1/5","D. 3/5"
            ]
          };
        }
      },
      // Q39
      {
        question: () => {
          const qHtml = `
            <p><strong>Q39:</strong> Class A=72,75,73,74,76 vs Class B=50,90,70,100,60. Which has bigger std dev?</p>
          `;
          return {
            q: qHtml,
            a: "B. Class B has bigger spread",
            distract: [
              "A. Class A bigger",
              "C. Equal st dev",
              "D. Not enough info"
            ]
          };
        }
      },
      // Q40
      {
        question: () => {
          const qHtml = `
            <p><strong>Q40:</strong> More study time => fewer gaming hours. Correlation type?</p>
          `;
          return {
            q: qHtml,
            a: "B. Negative correlation",
            distract: ["A. Positive correlation","C. No correlation","D. Causal relationship"]
          };
        }
      },
      // Q41
      {
        question: () => {
          const qHtml = `
            <p><strong>Q41:</strong> Solve -2x+5>1 => solution set?</p>
          `;
          return {
            q: qHtml,
            a: "A. x<2",
            distract: ["B. x>2","C. x<-2","D. x>-2"]
          };
        }
      },
      // Q42
      {
        question: () => {
          const qHtml = `
            <p><strong>Q42:</strong> 3<2x-1<=7. Solve for x:</p>
          `;
          return {
            q: qHtml,
            a: "B. 2<x<=4",
            distract: ["A. x<2","C. x<=4","D. 2<=x<4"]
          };
        }
      },
      // Q43
      {
        question: () => {
          const qHtml = `
            <p><strong>Q43:</strong> x+2y>4 & y<3. Which point satisfies both?</p>
          `;
          return {
            q: qHtml,
            a: "C. (4,0)",
            distract: ["A. (0,0)","B. (2,2)","D. (1,4)"]
          };
        }
      },
      // Q44
      {
        question: () => {
          const qHtml = `
            <p><strong>Q44:</strong> Graph y>2x+1 => which region to shade?</p>
          `;
          return {
            q: qHtml,
            a: "A. Above line",
            distract: ["B. Below line","C. On line only","D. No shading"]
          };
        }
      },
      // Q45
      {
        question: () => {
          const qHtml = `
            <p><strong>Q45:</strong> Perp to y=4x+2 => slope = -1/4. Which eq?</p>
          `;
          return {
            q: qHtml,
            a: "A. y=-1/4 x +5",
            distract: ["B. y=4x+5","C. y=-4x+1","D. y=1/4x-2"]
          };
        }
      },
      // Q46
      {
        question: () => {
          const qHtml = `
            <p><strong>Q46:</strong> f(x)=x^2-2x. Then f(a+1)=?</p>
          `;
          // f(a+1)=(a+1)^2 -2(a+1)=a^2+2a+1-2a-2=a^2-1
          return {
            q: qHtml,
            a: "A. a^2-1",
            distract: ["B. a^2+1","C. a^2-2a+1","D. a^2-2a-1"]
          };
        }
      },
      // Q47
      {
        question: () => {
          const qHtml = `
            <p><strong>Q47:</strong> g(x)=f(x)+3. Graph shift from y=f(x)?</p>
          `;
          return {
            q: qHtml,
            a: "A. 3 units up",
            distract: ["B. 3 units down","C. 3 right","D. 3 left"]
          };
        }
      },
      // Q48
      {
        question: () => {
          const qHtml = `
            <p><strong>Q48:</strong> h(x)=f(x-2). Shift from y=f(x)?</p>
          `;
          return {
            q: qHtml,
            a: "A. 2 right",
            distract: ["B. 2 left","C. 2 up","D. 2 down"]
          };
        }
      },
      // Q49
      {
        question: () => {
          const qHtml = `
            <p><strong>Q49:</strong> j(x)=-f(x). Transformation from f(x)?</p>
          `;
          return {
            q: qHtml,
            a: "A. Reflection across x-axis",
            distract: [
              "B. Reflection across y-axis",
              "C. Shift down by -1",
              "D. Shift horizontally by -1"
            ]
          };
        }
      },
      // Q50
      {
        question: () => {
          const qHtml = `
            <p><strong>Q50:</strong> k(x)=2f(x). How does it compare to y=f(x)?</p>
          `;
          return {
            q: qHtml,
            a: "A. Vertical stretch by factor 2",
            distract: ["B. Horizontal stretch","C. Shift up 2","D. Shift right 2"]
          };
        }
      }
    ];
  }